export class Viol3MatbeskedFetchedEventMessage {
    $type: string;
    kontraktId: number;
    message: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "Viol3MatbeskedFetchedEventMessage";
    constructor() {
        this.$type =  Viol3MatbeskedFetchedEventMessage.$type;
    }
}
